import { atom, selector } from "recoil";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";
// import moment from "moment";

export const caseReportListState = atom({
    key: 'caseReportListState',
    default: [],
})

export const caseReportAirlineState = atom({
    key: 'caseReportAirlineState',
    default: [],
})

export const filtersDefault = [
    {
        label: 'Period',
        size: 4,
        required: true,
        type: 'dateRange',
        value: '',
    },
    {
        label: 'Type',
        size: 2,
        required: true,
        type: 'select',
        value: { label: 'All Types', value: 'All' },
        list: [
            { label: 'All Types', value: 'All' },
            { label: 'AHL', value: 'AHL' },
            { label: 'DPR', value: 'DPR' },
            { label: 'OHD', value: 'OHD' },
            { label: 'UNCLAIMED', value: 'UNCLAIMED' },
            { label: 'CLAIMS', value: 'CLAIMS' },
        ]
    },
    {
        label: 'Airline',
        size: 3,
        required: true,
        type: 'select',
        value: { label: 'All Airlines', value: 'All' },
        list: [
            { label: 'All Airlines', value: 'All' },
        ]
    },
    {
        label: 'Status',
        size: 3,
        required: true,
        type: 'select',
        value: { label: 'All Status', value: 'All' },
        list: [
            { label: 'All Status', value: 'All' },
            { label: 'TRACING', value: 'TRACING' },
            { label: 'LOCATED', value: 'LOCATED' },
            { label: 'PARTIALLY LOCATED', value: 'PARTIALLY LOCATED' },
            { label: 'RECEIVED', value: 'RECEIVED' },
            { label: 'PARTIALLY RECEIVED', value: 'PARTIALLY RECEIVED' },
            { label: 'DELIVERED', value: 'DELIVERED' },
            { label: 'PARTIALLY DELIVERED', value: 'PARTIALLY DELIVERED' },
            { label: 'FORWARDED', value: 'FORWARDED' },
            { label: 'PARTIALLY FORWARDED', value: 'PARTIALLY FORWARDED' },
            { label: 'FORWARDED/DELIVERED', value: 'FORWARDED/DELIVERED' },
        ]
    },
]

export const caseReportDataStructureState = selector({
    key: 'caseReportDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: "Type",
                type: "text",
                order: { table: 1 },
            },
            { 
                label: "Reference",
                type: "text",
                order: { table: 2 },
            },
            { 
                label: "Flight Date",
                type: "datepicker",
                order: { table: 3 },
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
            },
            { 
                label: "Flight",
                type: "text",
                order: { table: 4 },
            },
            { 
                label: "Case Status",
                type: "text",
                order: { table: 5 },
            },
            { 
                label: "Name",
                type: "text",
                order: { table: 6 },
            },
            { 
                label: "Address",
                type: "select",
                order: { table: 7 },
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
